import {API} from '../API';

export class NoteService {

  async saveNote(task, data) {
    return (await API.getConnection())
      .post(`tasks/${task.id}/notes`, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
